import React from 'react';
import './SpecialSolutions_PageContent.css';


const SpecialSolutions_PageContent = () => {
    return (
        <div className="special-solutions-container">
            <div className="Page-Main_Dec">
                <h1 className="Page-title_LowerCase">Special Solutions</h1>
            </div>
            <h1 className="Section-title">Special Solutions for Challenging Architectural Designed Windows</h1>


            <div className="solution-section">
                <div className="solution-image">
                    <img src="/Assets/SpecialSolutions_Images/slant-1.webp" />
                </div>
                <div className="solution-text">
                    <h4>Blinds solution for Windows with Multifunctional Suitability and Shapes</h4>
                    <p>Callistus Window Blinds provides solution for Ideal indoor light protection, control and visual privacy – for sloped and inclined glass surfaces, patio roofs and asymmetrical conservatory glazing where the traditional window dressing cannot be prolific which is why blinds are a great solution for this window type. Callistus Colby blinds is a perfect choice for such windows and keep you warm in summer and cool in the winter. And our special fabrics are also ideally suited all kind of rooms and interior decor.</p>
                </div>
            </div>

            <div className="solution-section">
                <div className="solution-image">
                    <img src="/Assets/SpecialSolutions_Images/Skylight-Colby-1.webp" />
                </div>
                <div className="solution-text">
                    <h4>Skylight Blinds</h4>
                    <p>Skylight window treatments give those hard-to-reach windows the benefits of light blockage and extra insulation. Choose from cellular shades as “Callistus Colby Blinds” or Roman Shades to match the style of your room. Both with a wide range of fabrics operated by remote control systems <br /> <br />Enjoy the view of the sky from your room – The perfect light control solution for skylights and conservatories is our range of Callistus Skylight blinds</p>
                </div>
            </div>


            <div className="solution-section">
                <div className="solution-image">
                    <img src="/Assets/SpecialSolutions_Images/TDBU-3.webp" />
                </div>
                <div className="solution-text">
                    <h4>Top Down Bottom Up – Callistus Colby Blinds (TDBU)</h4>
                    <p>The Ultimate and Versatile, Callistus Top-Down/Bottom-Up window blinds offer you the ability to operate window treatments from the top down, bottom up, or in combination to meet all your privacy needs while still giving you access to natural light. It provides flexibility unlike other traditional blinds that only open one way from bottom upside, Callistus Colby Top-Down/Bottom-Up Operation gives you the liberty to customize the exact position of your blinds to fit your ideal level of privacy, light control and comfort.</p>
                    <h4>Day and Night – Callistus Colby Blinds</h4>
                    <p>Callistus Day and Night Honeycomb blind is a dynamic duo of beauty and practicality versatility.
                        A day & night blind is a single window treatment which utilizes both light filtering and room darkening fabric. The middle bar separating the two fabrics can be pushed down when light and privacy are desired and pushed up when greater light blockage is needed, or completely raised for a full view to the outside.Colby Day & Night blinds are available with the below Fabric Combinations:<br /> 1) Sheer – Translucent <br /> 2) Sheer – Blackout <br /> 3) Translucent – Blackout</p>
                </div>
            </div>

            <div className="solution-section">
                <div className="solution-image">
                    <img src="/Assets/SpecialSolutions_Images/conversion-option.webp" />
                </div>
                <div className="solution-text">
                    <h4>Unique Fabric Conversion available with Callistus Roman Blinds</h4>
                    <p>Unique Fabric Conversion option with Callistus Roman Blinds offer the versatility to convert Visible fabric to Translucent or Blackout, and Translucent fabric to Blackout by using lining fabric. We now have the flexibility to choose our desired design, texture, print, color with an option to utilize the same fabric with different fabric opacity at various locations to control Light, Privacy and temperature as per your mood and need.</p>
                </div>
            </div>

            <div className="solution-section">
                <div className="solution-image">
                    <img src="/Assets/SpecialSolutions_Images/remote-together.webp" />
                </div>
                <div className="solution-text">
                    <h4>Home Automation</h4>
                    <p>Callistus has solutions to use Home Automation as well as RTS system together for one Blind. With the use of custom design accessories one can control the same blind with remote as well as Home Automation system.</p>
                </div>
            </div>

            <div className="solution-section">
                <div className="solution-image">
                    <img src="/Assets/SpecialSolutions_Images/big-hight-1.webp" />
                </div>
                <div className="solution-text">
                    <h4>Heightened Window</h4>
                    <p>For the blinds in heighten windows it requires time-consuming efforts to wind up the blinds. In such cases Callistus provides RTS system or Home Automation in Blinds that helps to operate them via Remote which is capable of operating minimum 1 to 16 blinds together and individually or through Smartphone devices. We have the option of maximum running meters of fabric available for large heighten Windows</p>
                </div>
            </div>

            <div className="solution-section">
                <div className="solution-image">
                    <img src="/Assets/SpecialSolutions_Images/tdbu-4.webp" />
                </div>
                <div className="solution-text">
                    <h4>Wire free motor for Grayson Blinds</h4>
                    <p>Callistus also offers wire free motors to provide hassle free installation. With high battery life and almost zero maintenance, wire free are seen widely use these days.</p>
                </div>
            </div>

            <div className="solution-section">
                <div className="solution-image">
                    <img src="/Assets/SpecialSolutions_Images/cutrain-track-2.webp" />
                </div>
                <div className="solution-text">
                    <h4>Motorized Curtain Tracks</h4>
                    <p>Callistus also provides solution for curtain tracks that can be molded in curved shaped to be used while installing large curtains in curved tracks.</p>
                </div>
            </div>

            <div className="solution-section">
                <div className="solution-image">
                    <img src="/Assets/SpecialSolutions_Images/channel.webp" />
                </div>
                <div className="solution-text">
                    <h4>Complete Light Sealing Solution</h4>
                    <p>Callistus have specially designed Side Channel frame to eliminate the gap on the sides of  Blinds to control and limit light inside the room more precisely. Also to operate the blinds in a stiffer manner side channel can be utilized.</p>
                </div>
            </div>

            <div className="solution-section">
                <div className="solution-image">
                    <img src="/Assets/SpecialSolutions_Images/minimum-side-gap.webp" />
                </div>
                <div className="solution-text">
                    <h4>Minimum Gap between two Blinds</h4>
                    <p>Callistus motors are compatible to lift high weight of fabric; there are special types of Motors which are used to lift more than two adjacent blinds maintaining least gap in between. <br /> Use of intermediate brackets to close the gap between two separate blinds are some solutions that we put forward.</p>
                </div>
            </div>

            <div className="solution-section">
                <div className="solution-image">
                    <img src="/Assets/SpecialSolutions_Images/big-window-translucent.webp" />
                </div>
                <div className="solution-text">
                    <h4>Solution for wide Window</h4>
                    <p>Callistus Blinds have solutions to wide width windows where people find limitation on fabric choices or blinds types. Callistus’ fabrics are compatible for maximum reasonable width.</p>
                </div>
            </div>

            <div className="solution-section">
                <div className="solution-image">
                    <img src="/Assets/SpecialSolutions_Images/wooden.webp" />
                </div>
                <div className="solution-text">
                    <h4>Tilting in Window Venetian Blinds</h4>
                    <p>Wooden Venetian blinds feature vanes with 180 degrees tilting capacity for which special motors are being used. This motor not only helps the blinds to lift up but also helps in the tilting of the vanes 180 degrees at any position.</p>
                </div>
            </div>

            <div className="solution-section">
                <div className="solution-image">
                    <img src="/Assets/SpecialSolutions_Images/sierra-motors.webp" />
                </div>
                <div className="solution-text">
                    <h4>Curtain Look Blinds</h4>
                    <p>Callistus Sierra blinds are beautiful creation that implants the beauty of curtains with the benefits of blinds. In such blinds we used upgraded motors that not only stacks the blinds vertically in left or right or center splits but also tilts the vanes into 180 degrees vertically. This is the special solution that are rarely available.</p>
                </div>
            </div>

            <div className="solution-section">
                <div className="solution-image">
                    <img src="/Assets/SpecialSolutions_Images/french-doors.webp" />
                </div>
                <div className="solution-text">
                    <h4>Solution for Big Window</h4>
                    <p>Callistus Panel blinds are the specific solution for big windows or French doors. They can sometimes be also used as partition in rooms. Panel blinds can be stacked on either side and are available in 3-4-6 channel options both manual and motorized.</p>
                </div>
            </div>

            <div className="solution-section">
                <div className="solution-image">
                    <img src="/Assets/SpecialSolutions_Images/vertical-1.webp" />
                </div>
                <div className="solution-text">
                    <h4>Motorize Vertical Blinds</h4>
                    <p>For smooth vertical movement of the Blinds simultaneously tilting of the vanes in 180 degrees Callistus blinds uses specially designed motors. One can enjoy the beauty of various fabrics and light control to the room with a soft touch of the remote.</p>
                </div>
            </div>


        </div>
    );
};

export default SpecialSolutions_PageContent;
